export { default } from './TabsWrapper';
